<template>
  <div>
    Prêts professionnels
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'PretsProfessionnels'
}
</script>
